module.exports = __webpack_public_path__ + "assets/img/icon-badge-7361ea68.png";